<template>
	<div class="content_group ">
		<!-- content_group -->
		<div class="content_group_L ">
			<!-- content_group_L -->

			<div class="sticky1">
				<div class="left_nav m_b1">
					<!-- left_nav -->
					<h1><a href="javascript:;">权威声音栏目</a></h1>
					<ul class="left_nav_list">
						<li v-for="(item,index) in subcolumList" :class="[item.columnid==searchColum?'on':'']" ><a @click="searchClick(item.columnid)">{{item.columnnamesecond}}</a></li>
						<!-- <li class="on"><a href="">最新快讯</a></li>
						<li><a href="">经济增长</a></li>
						<li><a href="">消费扩内需</a></li>
						<li><a href="">投资补短板</a></li>
						<li><a href="">外资外贸</a></li>
						<li><a href="">产业发展</a></li>
						<li><a href="">经济结构</a></li>
						<li><a href="">物价稳定</a></li>
						<li><a href="">财税金融</a></li>
						<li><a href="">稳就业</a></li> -->
					</ul>
				</div><!-- /left_nav -->
			</div>


		</div><!-- /content_group_L -->
		<div class="content_group_R  ">
			<!-- content_group_R -->




			<!-- <div class="search_wrap  ">
				
				<div class="search_box">
					<input type="text" class="search_input2" value="" placeholder="输入查询内容" style="width:100%">
					<button type="button" class="search_btn2"></button>
				</div>
				<div class=" cei-select " name="cei-select">
					<i class="cei-icon icon-arrdown"></i>
					<input type="text" placeholder="时间不限" value="" disabled>
					<ul>
						<li><i></i>时间不限</li>
						<li><i></i>11111111</li>
						<li><i></i>333</li>
						<li><i></i>111</li>
						<li><i></i>222</li>
						<li><i></i>333</li>
					</ul>
				</div>
				<div class=" cei-select " name="cei-select">
					<i class="cei-icon icon-arrdown"></i>
					<input type="text" placeholder="地区选择" value="" disabled>
					<ul>
						<li><i></i>11111</li>
						<li><i></i>11111111</li>
						<li><i></i>333</li>
						<li><i></i>111</li>
						<li><i></i>222</li>
						<li><i></i>333</li>
					</ul>
				</div>
				<a href=""><i class="cei-icon icon-download icon-sty1"></i>下载</a>
			</div> -->




			<div class="thematic_list  ">
				<!-- thematic_list -->
				<section v-for="(result,index) in resultDataList" :key="result.id" >
					<dl>
						<dt>
							<div class="T-date">
								<d1>{{result.publishtime?result.publishtime.substring(8,10):''}}</d1>
								<d2>{{result.publishtime?result.publishtime.substring(0,7):''}}</d2>
							</div>
						</dt>
						<dd><router-link :to="{ name: 'detail', params: { id: result.id }}" class="T-tit" v-html="result.title"></router-link></dd>
					</dl>
					<!-- <dl>
						<dt></dt>
						<dd class="T-fla">
							<span class="T-source">来源：{{result.source}}</span>
						</dd>
					</dl> -->
					<dl>
						<dt>
							<T-vline></T-vline>
						</dt>
						<dd v-if="result.summary">
							<ul class="list4">
								<li><router-link :to="{ name: 'detail', params: { id: result.id }}">{{result.summary}}</router-link></li>
								<!-- <li><a href="">国常会决定带量采购“提速扩面”，高值医用耗材纳入集采成趋势高值医用耗材纳入集采材纳入集成趋势</a></li>
								<li><a href="">多地密集发布重大项目，新基建与新能源成为重要增长点</a></li>
								<li><a href="">IMF警示脆弱新兴经济体：即刻为潜在的经济动荡做准备</a></li>
								<li><a href="">刘和平：拜登对华科技战转向“精准脱钩”</a></li> -->
							</ul>
						</dd>
					</dl>
				</section>
				
			</div><!-- /thematic_list -->


			<div class="m_b1"></div>


			<el-row class="pagediv">
				<el-pagination
							@size-change="changePageSize"
							@current-change="changeSearchPage"
							:current-page="pageNum"
							:page-sizes="[10, 15, 20]"
							:page-size="10"
							layout="total, sizes, prev, pager, next, jumper"
							:total="totalResultCount">
						</el-pagination>
			</el-row>




		</div><!-- /content_group_R -->
	</div><!-- /content_group -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				searchColum: '',
				keyword: '',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
				subcolumList:[]
			}
		},
		props:[
			'ztsubid'
		],
		mounted:function(){
			this.subcolumfnc();
		},
		computed: {
	
		},
		methods: {
			subcolumfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'column/selectAllByparentID',
						responseType: 'json',
						params: {
							parentID: this.ztsubid,
						},
					})
					.then(function(response) {
						_this.subcolumList=response.data.data.data;
						if(_this.subcolumList.length>0){
							_this.searchClick(_this.subcolumList[0].columnid);
						}
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			searchClick: function(columnid) {
				if (columnid) {
					this.searchColum=columnid;
				}
				this.pageNum = 1;
				this.pageSize= 10;
				this.searchfnc();
			},
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'subject/getSubjectColumnArticles',
						responseType: 'json',
						params: {
							columnID:this.searchColum,
							iPage: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.searchfnc();
			},
			searchColumChange: function(index,indexPath) {
				// console.log(index);
				this.searchColum=index;
				this.pageNum = 1;
				// this.pageSize= 10;
				this.searchfnc();
			},
		}
	}
</script>

<style>
</style>
